module.exports = __webpack_public_path__ + "media/newstyle/images/icon-amazon-3a80d83301d9d4ee2f09119b53675aba.svg";